export default from './AccountingInsoft';



// WEBPACK FOOTER //
// ./src/containers/AccountingInsoft/index.js